<template>
    <div class="select-venue-address">
        <p class="title">Where will the event be?</p>
        <button
            ref="venues"
            @click="showVenues = !showVenues"
            :class="showVenues ? 'highlighted-btn' : ''"
            class="venue-selector"
        >
            <span :style="selectedVenue ? 'color: #dedede' : ''" class="selector-label">
                {{ selectedVenue ? selectedVenue.venue_name : 'Select a Venue' }}
            </span>
            <img :src="URLS.icons.arrowDown" alt="arrow-down" />
            <div v-if="showVenues" class="venue-list">
                <div
                    v-for="(venue, indx) in venues"
                    :key="indx"
                    @click.stop="() => selectVenue(venue)"
                    class="venue"
                >
                    <p class="venue-name">{{ venue.venue_name }}</p>
                    <p class="venue-location">{{ venue.address }}</p>
                </div>
            </div>
        </button>
        <button @click="showForm = true" class="add-new-address">Add new Venue</button>
        <AddVenueAddress
            v-if="showForm"
            @form-submit="addVenueAddress"
            @cancel-form="showForm = false"
        />
    </div>
</template>
<script>
    import axios from 'axios'
    import AddVenueAddress from './AddVenueAddress.vue'

    const URLS = {
        icons: {
            arrowDown: '/images/icons/arrow-down.svg'
        },
        xhr: {
            fetch: {
                getVenues: '/api/profile/venue'
            },
            mutate: {
                addVenue: '/api/profile/venue'
            }
        }
    }
    export default {
        name: 'SelectVenueAddress',
        components: { AddVenueAddress },
        props: {
            booker: {
                type: Object,
                required: true
            },
            selected: {
                type: Object
            }
        },
        emits: ['selected-venue'],
        data: () => ({
            selectedVenue: null,
            showVenues: false,
            showForm: false,
            venues: []
        }),
        computed: {
            URLS: () => URLS
        },
        watch: {
            selected: {
                immediate: true,
                handler(selected) {
                    if (selected) {
                        this.selectedVenue = selected
                    }
                }
            }
        },
        methods: {
            clickedDocument(event) {
                const targetElement = this.$refs.venues

                if (targetElement && !targetElement.contains(event.target)) {
                    this.showVenues = false
                }
            },
            selectVenue(venue) {
                this.showVenues = false
                this.selectedVenue = venue
                this.$emit('selected-venue', venue)
            },
            async fetchVenueAddresses() {
                try {
                    const response = await axios.get(
                        `${this.URLS.xhr.fetch.getVenues}/booker/${this.booker.id}/addresses`
                    )
                    this.venues = response.data.addresses
                } catch (error) {
                    console.error('error', error)
                }
            },
            addVenueAddress(data) {
                try {
                    this.venues.push(data)
                    this.$emit('selected-venue', data)
                } catch (error) {
                    console.error('error', error)
                } finally {
                    this.showForm = false
                }
            }
        },
        async created() {
            await this.fetchVenueAddresses()
        },
        mounted() {
            document.addEventListener('click', this.clickedDocument)
        },
        beforeDestroy() {
            document.removeEventListener('click', this.clickedDocument)
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    $selectorHeight: 48px;

    .select-venue-address {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        height: 542px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.64px;
        }
        .venue-selector.highlighted-btn {
            border: 1px solid #cdeb09;
        }
        .venue-selector {
            position: relative;
            max-width: 501px;
            width: 100%;
            max-height: $selectorHeight;
            margin-top: 8px;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 8px;
            border: 1px solid #8b8b8b;
            background: rgba(255, 255, 255, 0);
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;

            .selector-label {
                color: #646464;
                font-family: 'Instrument Sans';
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 133%;
            }
        }
        .add-new-address {
            background: none;
            padding-top: 8px;
            padding-bottom: 8px;
            color: #8b8b8b;
            font-family: 'Instrument Sans';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 115%;
            letter-spacing: 0.14px;
        }
        .venue-list {
            position: absolute;
            top: $selectorHeight;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;
            padding: 16px;
            border-radius: 12px;
            border: 1.5px solid #8b8b8b;
            background: #262626;

            .venue {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 8px;

                .venue-name {
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                }
                .venue-location {
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    text-align: left;
                }
                &:hover {
                    .venue-name {
                        color: #dedede;
                    }
                    .venue-location {
                        color: #dedede;
                    }
                }
            }
        }
    }
</style>
